const withParticipatingEmployees = participatingEmployees => prevTemplate => ({
    ...prevTemplate,
    participatingEmployees,
});

export default withParticipatingEmployees;
